import { moduleProviderFactory } from 'core/providers';
import { NikoInsuranceManagementEdit, NikoInsuranceManagementList } from 'application/niko-insurance-management/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.niko-insurance-management',
                pattern: '/niko-insurance-management',
                children: [
                    {
                        name: 'master.app.main.niko-insurance-management.list',
                        pattern: '',
                        tabTitle: 'NIKO_INSURANCE_MANAGEMENT.LIST.TITLE_SECONDARY',
                        component: NikoInsuranceManagementList,
                        data: {
                            title: 'NIKO_INSURANCE_MANAGEMENT.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.niko-insurance-management.create',
                        pattern: '/create',
                        tabTitle: 'NIKO_INSURANCE_MANAGEMENT.CREATE.TAB_TITLE',
                        component: NikoInsuranceManagementEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'NIKO_INSURANCE_MANAGEMENT.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.niko-insurance-management.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'NIKO_INSURANCE_MANAGEMENT.EDIT.TAB_TITLE',
                        component: NikoInsuranceManagementEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'NIKO_INSURANCE_MANAGEMENT.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 8,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.NIKO_INSURANCE_MANAGEMENT_SUB',
                        route: 'master.app.main.niko-insurance-management.list',
                        order: 5.2,
                    }                    
                ]
            }
        ]
    });
})();
